import { render, staticRenderFns } from "./ProtectionContract.vue?vue&type=template&id=0ae59971&"
import script from "./ProtectionContract.vue?vue&type=script&lang=js&"
export * from "./ProtectionContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports